module.exports = __webpack_public_path__ + "img/view-orders.8d5a4271.jpg";